import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef
} from '@angular/core';
import {createPopper, Instance as PopperInstance, Placement as PopperPlacement} from '@popperjs/core';
import {ModalService} from '../modal';
import {OverlayService} from '../overlay';
import {PopperOptions} from '../popper-utils/popper-options';

@Component({
    selector: 'tpl-dropdown',
    templateUrl: './template-dropdown.component.html',
    styleUrls: ['./template-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TemplateDropdownComponent<T> implements OnInit, AfterViewInit, OnDestroy {

    @Input()
    public templateRef: TemplateRef<T>;

    @Input()
    public targetElement: ElementRef;

    @Input()
    public placement: PopperPlacement;

    @Input()
    public popperOptions: PopperOptions;

    private popper: PopperInstance;

    constructor(
        private elementRef: ElementRef,
        private modalService: ModalService,
        private overlayService: OverlayService
    ) {}

    public ngOnInit(): void {
        this.createOverlay();
    }

    public ngAfterViewInit(): void {
        this.initPopper();
    }

    public ngOnDestroy(): void {
        this.destroyPopper();
    }

    public close(): void {
        this.modalService.close(this);
    }

    protected initPopper(): void {
        this.popper = createPopper(
            this.targetElement.nativeElement,
            this.elementRef.nativeElement,
            {
                placement: 'bottom',
                ...(this.popperOptions || {})
            }
        );

        this.popper.update();
    }

    protected destroyPopper(): void {
        if (this.popper) {
            this.popper.destroy();
        }
    }

    protected createOverlay(): void {
        this.overlayService.create({
            target: this.modalService.getByInstance(this)
        }).subscribe(() => this.close());
    }

}
